import React, { PropsWithChildren } from 'react';
import { StyledFormGroup } from './styles';

export const FormGroup: React.FC<PropsWithChildren> = ({ children }) => (
  <StyledFormGroup>{children}</StyledFormGroup>
);
